<template lang="pug">
.section-wrapper__container
  vs-row
    vs-col(:w="12")
      vs-row(align="center")
        h2 Contenido de Página Principal
        vs-button(transparent href="https://pimsaseguros.com/" blank) Ver pagina principal
    vs-col(:w="12")
      v-tabs(paddingX variant="centered")
        v-tab(name="Banners" :selected="true")
          v-headers-table
        v-tab(name="Lo nuevo de PIMSA")
          v-home-buttons-table
        v-tab(name="Carrousel de Aseguradoras")
          v-insurance-table
        v-tab(name="Actividades")
          v-activities-table
        v-tab(name="Carrousel de Testimoniales")
          v-testimonial-table
</template>

<script>
import { VTabs, VTab } from '@/components/tabs'
import { VInsuranceTable, VTestimonialTable, VHomeButtonsTable, VActivitiesTable, VHeadersTable } from '@/components/tables'
import HeaderInformation from '@/components/home/HeaderInformation.vue'

export default {
  name: 'HomeDetails',
  components: {
    VTabs,
    VTab,
    VInsuranceTable,
    VTestimonialTable,
    HeaderInformation,
    VHomeButtonsTable,
    VActivitiesTable,
    VHeadersTable
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
